import styled from 'styled-components';
import { hPadder } from '$util/theme/spacers/horizontals';

export const Styled = styled.section`
  ${hPadder('top', 'M')}
  ${hPadder('bottom', 'M')}
`;
